import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white">
      {/* Top Section - Four Column Grid */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand Column */}
          <div>
            <Link to="/" className="font-heading text-lg md:text-xl font-bold tracking-wide whitespace-nowrap">
              PANDABUY.BEER
            </Link>
            <p className="mt-3 text-sm text-white/55 leading-relaxed max-w-xs">
              Your trusted directory for the best pandabuy spreadsheet links. Updated daily with verified products across 14 categories.
            </p>
          </div>

          {/* Stay Updated */}
          <div>
            <h5 className="text-xs font-semibold uppercase tracking-wider text-white/45 mb-4 whitespace-nowrap">
              Stay Updated
            </h5>
            <p className="text-sm text-white/55 leading-relaxed">
              New links added daily. Bookmark pandabuy.beer to stay ahead of the latest drops and trending products.
            </p>
          </div>

          {/* Categories */}
          <div>
            <h5 className="text-xs font-semibold uppercase tracking-wider text-white/45 mb-4 whitespace-nowrap">
              Categories
            </h5>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com/category-911-Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap"
                >
                  Shoes
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap"
                >
                  Hoodies/Sweaters
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-921/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap"
                >
                  Bags
                </a>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h5 className="text-xs font-semibold uppercase tracking-wider text-white/45 mb-4 whitespace-nowrap">
              Quick Links
            </h5>
            <ul className="space-y-2.5">
              <li>
                <Link to="/pandabuy-sheet-guide" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href="#categories" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">
                  All Categories
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Brand Text */}
      <div className="border-t border-white/10 py-8 md:py-10 text-center">
        <p className="text-5xl md:text-7xl lg:text-9xl font-heading font-bold text-white/8 tracking-tighter whitespace-nowrap select-none">
          PANDABUY.BEER
        </p>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10 py-4 text-center">
        <p className="text-xs text-white/35">
          &copy; {new Date().getFullYear()} pandabuy.beer. All external links open in new tabs.
        </p>
      </div>
    </footer>
  );
}